var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 243.68 241.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".neptyne-logo-svg{fill:#b4b4b4;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "neptyne-logo-svg",
    x: 182.77,
    y: 180.74,
    width: 60.91,
    height: 60.91,
    transform: "translate(2.03 424.42) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "neptyne-logo-svg",
    x: 185.75,
    y: 183.72,
    width: 54.94,
    height: 54.94,
    transform: "translate(2.03 424.42) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "neptyne-logo-svg",
    x: 91.38,
    y: 180.74,
    width: 60.91,
    height: 60.91,
    transform: "translate(-89.36 333.03) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "neptyne-logo-svg",
    x: 94.37,
    y: 183.72,
    width: 54.94,
    height: 54.94,
    transform: "translate(-89.35 333.03) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "neptyne-logo-svg",
    y: 180.74,
    width: 60.91,
    height: 60.91,
    transform: "translate(-180.74 241.65) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "neptyne-logo-svg",
    x: 2.99,
    y: 183.72,
    width: 54.94,
    height: 54.94,
    transform: "translate(-180.74 241.65) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "neptyne-logo-svg",
    x: 91.38,
    y: 90.37,
    width: 60.91,
    height: 60.91,
    transform: "translate(1.01 242.66) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "neptyne-logo-svg",
    x: 94.37,
    y: 93.35,
    width: 54.94,
    height: 54.94,
    transform: "translate(1.01 242.66) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "neptyne-logo-svg",
    y: 90.37,
    width: 60.91,
    height: 60.91,
    transform: "translate(-90.37 151.28) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "neptyne-logo-svg",
    x: 2.99,
    y: 93.36,
    width: 54.94,
    height: 54.94,
    transform: "translate(-90.37 151.28) rotate(-90)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "neptyne-logo-svg",
    points: "182.78 151.29 182.78 60.9 91.4 60.9 91.4 0.01 243.66 0.01 243.66 151.29 182.78 151.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "neptyne-logo-svg",
    points: "185.76 148.3 185.76 57.91 94.38 57.91 94.38 3 240.68 3 240.68 148.3 185.76 148.3"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "neptyne-logo-svg",
    width: 60.91,
    height: 60.91,
    transform: "translate(0 60.91) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "neptyne-logo-svg",
    x: 2.99,
    y: 2.99,
    width: 54.94,
    height: 54.94,
    transform: "translate(0 60.91) rotate(-90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGray);
export default __webpack_public_path__ + "static/media/logoGray.5e31f59bbae20c0bbe875daacec324b9.svg";
export { ForwardRef as ReactComponent };